import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'

import styles from './RouteFallback.scss'

/**
 * Shown inside the route layout while a lazy route chunk is loading.
 * Keeps header/footer visible instead of a full-viewport spinner.
 */
const RouteFallback = () => (
  <div className={styles.fallback} role="status" aria-live="polite" aria-busy="true">
    <CircularProgress size={60} thickness={7} />
  </div>
)

export default RouteFallback
